import {API_URL} from '../constants.js';

export async function getProducts(apps, referralCode) {
  const referralCodesQuery = referralCode ? `&referralCodes=${referralCode}` : '';
  const res = await fetch(`${API_URL}products.json?apps=${apps.join(',')}${referralCodesQuery}`);

  return res.json();
}
